/*--------------------------------------------------------------------------*
 * お問い合せリアルタイムバリデーション
 *--------------------------------------------------------------------------*/
module Module_Inquiry {
	export class Model_Inquiry {
        // チェック実行結果に応じてボタンのプロパティを変更
        change_btn_prop(btn: JQuery, config_arr: { type: string, name: string }[]): void {
            this.exe_check(config_arr)
                ? btn.prop('disabled', false)
                : btn.prop('disabled', true);
        }

        /* ****************************** */
        /* チェックの実行
        /* array = [
        /*  {
        /*      type    : input.attr('type'),
        /*      name    : input.attr('name'),
        /*  }
        /* ]
        /* ****************************** */
        exe_check(array: { type: string, name: string }[]): boolean {
            let check_arr: boolean[] = [];

            for(let i=0; i<array.length; i++) {
                let result: boolean;
                switch(array[i]['type']) {
                    case 'text':
                        result = this.check_text(array[i]['name']);
                        break;
                    case 'textarea':
                        result = this.check_textarea(array[i]['name']);
                        break;
                    case 'radio':
                        result = this.check_radio(array[i]['name']);
                        break;
                    case 'checkbox':
                        result = this.check_checkbox(array[i]['name']);
                        break;
                }
                check_arr.push(result);
            }

            return check_arr.filter(function(elm) { return elm === true }).length >= array.length ? true : false;
        }

        // テキストの入力チェック
        check_text(name: string): boolean {
            const input = $('input[name="'+name+'"]');
            return input.val() !== "" ? true :  false;
        }

        // テキストの入力チェック
        check_textarea(name: string): boolean {
            const textarea = $('textarea[name="'+name+'"]');
            return textarea.val() !== "" ? true :  false;
        }

        // ラジオボタンの入力チェック
        check_radio(name: string): boolean {
            const input = $('input[name="' + name + '"]');
            let result = false;

            input.each(function(): boolean {
                if($(this).attr('checked')) {
                    result = true;
                    return false;
                }
            });

            return result;
        }

        // チェックボタンの入力チェック
        check_checkbox(name: string): boolean {
            const input: JQuery = $('input[name="' + name + '"]');
            let counter: number = 0;

            input.each(function(): void {
                if($(this).attr('checked')) counter++;
            });

            return counter > 0 ? true : false;
        }
	}
}
